import { Component, OnInit, AfterViewInit, OnDestroy, inject, input } from "@angular/core";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { filter } from "rxjs/operators";
import { NxCellRows, QTable } from "qlik";
import { Subscription } from "rxjs";
import { NgClass } from "@angular/common";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";
import { IQlikLib } from "../../qliklib/qliklib";
import { QlikService } from "../../services/qlik.service";

@Component({
  selector: "stat-qlik-graf",
  templateUrl: "./graf.component.html",
  imports: [NgClass, ButtonComponent],
})
export class GrafComponent implements OnInit, AfterViewInit, OnDestroy {
  private qlikService = inject(QlikService);
  private sanitizer = inject(DomSanitizer);

  readonly id = input<string>(); // Qlik graph object id
  readonly height = input(300); // Height of the graph box (is set in Qlik)
  readonly width = input<number | "auto">("auto");
  readonly statistikkType = input<string>(); //Type statistikk som er valgt
  readonly typeTekst = input<string>(); //Type tekst som er valgt
  readonly noSelections = input(false); //Styrer om det er mulig å gjøre filtervalg i grafen
  readonly noInteraction = input(false); //Styrer om grafen reagerer på klikk, hover, scroll o.l.
  readonly valgtFilter = input<string>(); //Hvilke filter fra filterlisten som er valgt

  objectKeys = Object.keys;
  sizeStyle: SafeStyle = null;
  visDatagrunnlagUtvidet = false;
  idPrefix = "qv-graf-";
  // Collector for closing observables when done
  collector: Subscription = new Subscription();
  tabell: NxCellRows[] = null;
  visSomTabell = false;
  filterItem: string = null;
  filterList: string;
  qTable: QTable;

  ngOnInit() {
    let style = "height: " + this.height() + "px;";
    const width = this.width();
    if (width !== "auto") {
      style += " width: " + width + "px;";
    }
    this.sizeStyle = this.sanitizer.bypassSecurityTrustStyle(style);
  }

  ngAfterViewInit() {
    this.qlikService
      .getQliklib()
      .pipe(filter(qliklib => qliklib))
      .subscribe((qliklib: IQlikLib) => {
        const id = this.id();
        if (this.qlikService.isGrafId(id)) {
          const selector = "#" + this.idPrefix + id;

          const options = {
            noInteraction: this.noInteraction(),
            noSelections: this.noSelections(),
          };

          qliklib.displayQlikObjects(selector, options);
        } else {
          throw "Error: Qlik object ID '" + id + "' not registered";
        }
      })
      .add(this.collector);
  }

  ngOnDestroy() {
    this.qlikService
      .getQliklib()
      .subscribe((qliklib: IQlikLib) => {
        this.qTable = null;
        qliklib?.closeQlikObjects(this.idPrefix + this.id());
      })
      .unsubscribe();

    if (this.qlikService.exportDataListe[this.idPrefix + this.id()]) {
      delete this.qlikService.exportDataListe[this.idPrefix + this.id()];
    }

    this.collector.unsubscribe();
  }

  saveAsExcel() {
    this.qlikService.saveAsExcel(this.idPrefix + this.id(), this.valgtFilter());
  }

  exportData() {
    this.visSomTabell = !this.visSomTabell;

    this.qlikService
      .getTableData(this.idPrefix + this.id())
      .subscribe((tabell: NxCellRows[]) => {
        this.tabell = tabell;
      })
      .unsubscribe();

    this.qlikService
      .getQliklib()
      .subscribe((qliklib: IQlikLib) => {
        this.qTable = qliklib?.getQTable(this.idPrefix + this.id());

        const id = this.id();
        if (this.qlikService.isGrafId(id)) {
          qliklib.displayQlikObjects("#" + this.idPrefix + id);
        }
      })
      .add(this.collector);
  }

  getTable() {
    this.qlikService
      .getTableData(this.idPrefix + this.id())
      .subscribe((tabell: NxCellRows[]) => {
        this.tabell = tabell;
      })
      .unsubscribe();
    return this.tabell;
  }

  hentFilterListe() {
    let list = [];
    let filterDescription = "Grafen viser " + (this.typeTekst() + " med " + this.statistikkType()).toLowerCase();
    list = this.qlikService.hentValgtFilterListe(this.valgtFilter());
    if (list && list.length > 0) {
      filterDescription = filterDescription + " for";
    }
    filterDescription = filterDescription + list + ".";
    return filterDescription;
  }
}
